var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 119,
    viewBox: "0 0 140 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9023 114.534C25.833 118.344 36.2626 118.493 50.6426 118.493L50.6469 118.485H54.4569C100.79 118.485 121.623 118.046 130.108 105.071C137.021 94.5008 149.37 53.6679 128.085 43.4212C117.869 40.0156 95.3833 29.4499 85.4179 24.5927L85.3988 24.5816C75.5951 18.8823 67.5873 14.227 57.3346 14.227C54.0355 14.227 50.5022 14.7123 46.6028 15.7978C19.4518 23.3582 27.4038 43.698 12.6832 53.6679C1.13829 61.4837 -4.63416 81.2743 4.52259 100.124C7.07677 105.382 9.05627 109.102 13.4793 111.818L17.9023 114.534Z",
    fill: "#FDFC96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3039 50.5299L101.243 72.0552L57.9193 99.3267L18.8818 76.9805L64.3039 50.5299Z",
    fill: "#7886AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1284 0L64.3042 50.5297L101.244 72.0551L101.791 24.1704L66.1284 0Z",
    fill: "#58587A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 0L64.3039 50.5298L18.8818 76.9803L19.7027 26.5418L66.1281 0Z",
    fill: "#235355"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7027 26.5418L59.0138 48.0671L58.0105 99.3265L18.8818 76.9803L19.7027 26.5418Z",
    fill: "url(#paint0_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.128 0L19.7026 26.5418L59.0137 48.0671L101.791 24.1704L66.128 0Z",
    fill: "#8F9CC0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.791 24.1702L101.244 72.0549L128.789 68.7713L128.241 18.6064L101.791 24.1702Z",
    fill: "#A7B6DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1481 31.5584L58.9229 48.1585L101.7 24.1705L117.205 4.743L72.1481 31.5584Z",
    fill: "#75809D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9194 99.3265L58.9227 48.1583L40.8633 63.299L43.1435 117.477L57.9194 99.3265Z",
    fill: "#A7B6DD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.244 72.0551L57.9194 99.3265L87.836 110.454L134.353 80.4463L101.244 72.0551Z",
    fill: "#A0AFD3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.393,
    y1: 78.9024,
    x2: 95.8416,
    y2: 61.7181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/empty-list.0a7ef9b4.svg";
export { ForwardRef as ReactComponent };